/** Mapping chemins admin → module RBAC (lecture requise pour voir le menu). */
export const ADMIN_NAV_MODULES = {
  "/admin": "dashboard",
  "/admin/my-pharmacies": "my_pharmacies",
  "/admin/clients": "clients",
  "/admin/search-analytics": "medicine_stats",
  "/admin/medicine-stats": "medicine_stats",
  "/admin/pharmacies": "pharmacies",
  "/admin/doctors": "doctors",
  "/admin/medicines": "medicines",
  "/admin/medicine-forms": "medicine_forms",
  "/admin/medicine-categories": "medicine_categories",
  "/admin/subscription-stats": "subscription_stats",
  "/admin/subscription-pharmacies": "subscription_pharmacies",
  "/admin/plans": "plans",
  "/admin/deliveries": "deliveries",
  "/admin/delivery-pricing": "delivery_pricing",
  "/admin/subscription-management": "subscription_management",
  "/admin/payments": "payments",
  "/admin/payment-history": "payment_history",
  "/admin/payment-config": "payment_config",
  "/admin/settings": "settings",
  "/admin/admin-users": "admin_users",
  "/admin/admin-roles": "admin_roles",
  "/admin/kam-users": "kam_users",
  "/admin/kam-commissions": "kam_commissions",
  "/admin/doctor-commission-config": "doctor_commission_settings",
  "/admin/doctor-commissions": "doctor_commissions",
  "/admin/configuration": "settings",
  "/admin/configuration/site": "settings",
  "/admin/configuration/monetization/accounts": "payment_config",
  "/admin/configuration/monetization/plans-mm": "plans",
  "/admin/configuration/monetization/plans-stripe": "subscription_management",
  "/admin/configuration/commissions/kam": "kam_settings",
  "/admin/configuration/commissions/doctor": "doctor_commission_settings",
  "/admin/configuration/delivery": "delivery_pricing",
  "/admin/configuration/access/users": "admin_users",
  "/admin/configuration/access/roles": "admin_roles",
};

export function canReadModule(user, moduleCode) {
  if (!user || user.role !== "admin") return false;
  if (user.admin_is_super) return true;
  return Boolean(user.admin_permissions?.[moduleCode]?.read);
}

export function canWriteModule(user, moduleCode, action = "update") {
  if (!user || user.role !== "admin") return false;
  if (user.admin_is_super) return true;
  return Boolean(user.admin_permissions?.[moduleCode]?.[action]);
}

export function canAccessAdminPath(user, path) {
  if (!user || user.role !== "admin") return false;
  if (path === "/admin/change-password") return true;
  if (path === "/admin/medicine-stats") {
    return canReadModule(user, "medicine_stats");
  }
  if (path === "/admin/search-analytics") {
    return canReadModule(user, "search_analytics");
  }
  if (path === "/admin/configuration") {
    return Object.entries(ADMIN_NAV_MODULES).some(
      ([p, module]) =>
        p.startsWith("/admin/configuration/") && canReadModule(user, module)
    );
  }
  const module = ADMIN_NAV_MODULES[path];
  if (!module) return user.admin_is_super;
  return canReadModule(user, module);
}
